/**
 * Reloj compartido (F3-G): UNA sola señal `now` que avanza cada `intervalMs` y a
 * la que se suscriben todos los badges/cuentas atrás. Evita crear un `setInterval`
 * por componente. El intervalo se detiene cuando no hay suscriptores.
 */
import { createSignal, onCleanup } from "solid-js";

const [nowMs, setNowMs] = createSignal(Date.now());
let timer: ReturnType<typeof setInterval> | null = null;
let subscribers = 0;

const TICK_MS = 1000;

function start(): void {
  if (timer === null) {
    timer = setInterval(() => setNowMs(Date.now()), TICK_MS);
  }
}

function stop(): void {
  if (timer !== null) {
    clearInterval(timer);
    timer = null;
  }
}

/**
 * Accessor reactivo del instante actual (epoch ms), que avanza cada segundo
 * mientras el componente suscriptor viva.
 */
export function useNow(): () => number {
  subscribers += 1;
  start();
  onCleanup(() => {
    subscribers -= 1;
    if (subscribers <= 0) {
      subscribers = 0;
      stop();
    }
  });
  return nowMs;
}
